import React, { useEffect, useState } from 'react';

const CONFIRMATION_TEXT = 'REMOVE XMIT';

export default function RemoveXmitModal({
  user,
  xmitNumber,
  open,
  loading,
  onCancel,
  onConfirm,
}) {
  const [confirmation, setConfirmation] = useState('');

  useEffect(() => {
    if (open) {
      setConfirmation('');
    }
  }, [open, user?.id, xmitNumber]);

  if (!open) return null;

  const displayName =
    user?.name ||
    `${user?.firstName || ''} ${user?.lastName || ''}`.trim() ||
    user?.email ||
    'User';

  const currentXmit = xmitNumber || user?.quickResponse?.xmitNumber;

  const canRemove = confirmation === CONFIRMATION_TEXT && !loading;

  return (
    <div
      className="fixed inset-0 bg-slate-900/40 backdrop-blur-xs flex items-center justify-center z-[9999] p-4"
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-2xl max-w-md w-full p-6 border border-slate-100 shadow-xl flex flex-col gap-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-12 h-12 bg-amber-50 border border-amber-200 text-amber-600 rounded-full flex items-center justify-center text-xl">
          <i className="fas fa-tower-broadcast" />
        </div>

        <div className="flex flex-col gap-2">
          <h2 className="font-bold text-slate-900 text-lg m-0">Remove XMIT assignment?</h2>
          <p className="text-sm text-slate-600 m-0">
            This will remove XMIT <strong className="font-mono">{currentXmit || '—'}</strong>
            {user ? (
              <>
                {' '}from <strong>{displayName}</strong>
                {user.email ? ` (${user.email})` : ''}
              </>
            ) : null}
            . The device will be taken out of service in Quick Response.
          </p>
        </div>

        <div>
          <label
            htmlFor="remove-xmit-confirmation"
            className="block text-xs font-semibold text-slate-600 mb-2"
          >
            Type <span className="font-mono text-amber-700">{CONFIRMATION_TEXT}</span> to confirm
          </label>
          <input
            id="remove-xmit-confirmation"
            type="text"
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
            placeholder={CONFIRMATION_TEXT}
            autoComplete="off"
            className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-200"
          />
        </div>

        <div className="flex gap-3 justify-end pt-1">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 border rounded-lg text-sm font-semibold text-slate-600 hover:bg-slate-50 disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(confirmation)}
            disabled={!canRemove}
            className="px-4 py-2 bg-amber-600 text-white rounded-lg text-sm font-semibold hover:bg-amber-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Removing…' : 'Remove XMIT'}
          </button>
        </div>
      </div>
    </div>
  );
}

export { CONFIRMATION_TEXT as REMOVE_XMIT_CONFIRMATION };
